






















// @ is an alias to /src
import Vue from 'vue';
import ApiRequest from '@/util/apiRequest';

import { API_TOURNAMENT_QUERY } from '../../util/config';

export default Vue.extend({
  name: 'home',
  data() {
    return {
      tournaments: [],
      showDescriptions: false,
    };
  },
  methods: {
    async load() {
      const response = await ApiRequest.Get(API_TOURNAMENT_QUERY);
      this.$data.tournaments = response;
    },
  },
  mounted() {
    this.load();
  },
});
